<template>
  <div class="approval-group">
    <label class="title">{{ label }}</label>
    <div class="card-body">
      <template v-if="!isEstabelecimento">
        <div class="text text-upper mb-1">{{ valueModel }}</div>
      </template>
      <template v-else>
        <template v-if="type == 'text'">
          <input
            type="text"
            :name="name"
            :required="required"
            v-model="valueModel"
            :maxlength="maxlength"
          />
        </template>
        <template v-else-if="type == 'textarea'">
          <textarea
            :name="name"
            :required="required"
            v-model="valueModel"
          ></textarea>
        </template>
      </template>
      <div v-if="value != '' || !isEstabelecimento">
        <b>Status:</b>
        <span
          :class="{
            text: true,
            'text-upper': true,
            'text-bold': true,
            'text-success': status == 7,
            'text-red': status == 8,
            'text-warning': status == 9 || (!status && statusEtapa3 == 9)
          }"
          >{{ statusName }}</span
        >
      </div>
      <div v-if="considerations != '' && isEstabelecimento">
        <b>Considerações:</b>
        <span class="text text-upper">{{ considerations }}</span>
      </div>
    </div>
    <template v-if="!isEstabelecimento">
      <div v-if="statusEtapa3 == 9">
        <div class="footer">
          <input
            type="button"
            value="Avaliar"
            class="btn btn-secondary btn-sm"
            role="button"
            @click="showModal = true"
          />
        </div>
        <modal-component
          title="Avaliar"
          :value="showModal"
          @input="onCloseModal"
        >
          <div class="modal-content">
            <div class="form-group required">
              <label :for="name + '-status'">Avaliação</label>
              <select
                :name="'evaluation[status][' + nameKey + ']'"
                :id="name + '-status'"
                class="form-control"
                v-model="status"
              >
                <option value="9">Pendente</option>
                <option value="7">Aprovado</option>
                <option value="8">Reprovado</option>
              </select>
            </div>
            <div class="form-group">
              <label :for="name + '-textarea'">Considerações</label>
              <textarea
                :name="'evaluation[consideracoes][' + nameKey + ']'"
                :id="name + '-textarea'"
                class="form-control"
                v-model="considerations"
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <input
              type="button"
              value="Salvar"
              class="btn btn-secondary"
              @click="onSaveCkick"
            />
          </div>
        </modal-component>
      </div>
      <input type="hidden" :name="name" :required="required" v-model="value" />
    </template>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      required: false
    },
    value: {
      required: false
    },
    name: {
      required: true
    },
    isEstabelecimento: {
      required: true
    },
    type: {
      required: false,
      default: "text"
    },
    required: {
      required: false,
      default: false
    },
    statusEtapa3: {
      required: true
    },
    evaluation: {
      required: false
    },
    maxlength: {
      required: false,
      default: 255
    }
  },
  data: () => ({
    valueModel: "",
    showModal: false,
    status: null,
    considerations: ""
  }),
  computed: {
    nameKey() {
      return this.name.replace("[", "-").replace("]", "");
    },
    statusName() {
      if (this.statusEtapa3 != 9 && !this.status) {
        return "-";
      }
      switch (parseInt(this.status)) {
        case 7:
          return "Aprovado";
        case 8:
          return "Reprovado";
        default:
          return "Pendente";
      }
    }
  },
  methods: {
    onSaveCkick() {
      let hasError = false;
      this.$el.querySelectorAll(".form-group.required").forEach(node => {
        const formControl = node.querySelector(".form-control");
        if (!formControl.value) {
          node.classList.add("error");
          hasError = true;
        } else {
          node.classList.remove("error");
        }
      });

      if (!hasError) {
        this.showModal = false;
      }
    },
    onCloseModal() {
      this.showModal = false;
    }
  },
  mounted() {
    if (this.evaluation && this.evaluation.cod_form_evaluation_etapa3) {
      this.status = this.evaluation.status;
      this.considerations = this.evaluation.observacoes;
    }

    if (this.value) {
      this.valueModel = this.value;
    }
  }
};
</script>
<style lang="scss" scoped>
.approval-group {
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0px 0px 2px #000;

  .title {
    padding: 6px;
    background: #2b6f10;
    color: #fff;
    font-weight: bold;
    margin: 0;
  }

  .card-body {
    padding: 9px;
  }

  .footer {
    background: #e8e8e8;
    text-align: right;
    padding: 4px;
  }
}

/deep/ .sida-modal {
  max-width: 450px;
  .modal-content {
    height: auto;
  }

  .modal-footer {
    text-align: right;
  }
}
</style>
